import { render, staticRenderFns } from "./cPartida.vue?vue&type=template&id=a959d580&"
import script from "./cPartida.vue?vue&type=script&lang=js&"
export * from "./cPartida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports